var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "selection",
      class: [
        _vm.tab,
        _vm.isInterRelated ? "interRelated-" + _vm.isInterRelated : "",
        {
          isLive: _vm.isLive,
          priceUp: _vm.priceUp,
          priceDown: _vm.priceDown,
          hcpUp: _vm.hcpUp,
          hcpDown: _vm.hcpDown,
          isClosed: _vm.isClosed,
          isSuspended: _vm.isSuspended,
          edit: _vm.currentBetSlipState == 0,
          review: _vm.currentBetSlipState == 1,
          optedOut: !_vm.optedIn[_vm.id],
          oddsBust: _vm.pricetype === "XP",
          interRelated: _vm.isInterRelated,
          isForSinglesOnly: _vm.isForSinglesOnly,
          isForBB: _vm.isForBB
        }
      ]
    },
    [
      _c("div", { staticClass: "columns" }, [
        _c(
          "div",
          { staticClass: "column column-left" },
          [
            _vm.showCheckbox === true
              ? _c("v-checkbox", {
                  attrs: {
                    type: "checkbox",
                    id: _vm.id.toString(),
                    value: _vm.optedIn[_vm.id],
                    disabled: _vm.disableOptedIn
                  },
                  on: {
                    change: function($event) {
                      return _vm.updateOptedIn()
                    }
                  },
                  model: {
                    value: _vm.optedIn[_vm.id],
                    callback: function($$v) {
                      _vm.$set(_vm.optedIn, _vm.id, $$v)
                    },
                    expression: "optedIn[id]"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.showCheckbox
              ? _c("icon", {
                  attrs: {
                    colorName: "blue",
                    name:
                      "icon-" +
                      (_vm.selection.idfosporttype &&
                        _vm.selection.idfosporttype.split(" ").join(""))
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        !_vm.betslipLayout2
          ? _c(
              "div",
              {
                staticClass: "column column-right",
                on: {
                  click: function($event) {
                    return _vm.toggleOptedIn()
                  }
                }
              },
              [
                _c("label", { attrs: { for: _vm.id } }, [
                  _c("div", { staticClass: "selection-data" }, [
                    _c("div", { staticClass: "event-name" }, [
                      _c("span", { staticClass: "eventname" }, [
                        _c("span", { staticClass: "name-lines" }, [
                          _c("span", { staticClass: "name-line" }, [
                            _vm._v(_vm._s(_vm.wbr(_vm.eventName, 0)))
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "name-line" }, [
                            _vm._v(_vm._s(_vm.wbr(_vm.eventName, 1)))
                          ])
                        ]),
                        _vm._v(" "),
                        _vm.isForBB
                          ? _c(
                              "span",
                              { staticClass: "isForBB" },
                              [
                                _c("icon", {
                                  attrs: { name: "icon-available-for-bb" }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _vm.isLive
                        ? _c("span", { staticClass: "isLive" }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("BetSlip.selection.isLive")))
                            ])
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "selection-name" }, [
                      _c("span", { staticClass: "name" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.selectionName) +
                            "\n                "
                        ),
                        _vm.selection &&
                        typeof _vm.selection.currenthandicap == "number"
                          ? _c(
                              "span",
                              {
                                staticClass: "currenthandicap",
                                class: [
                                  { hcpUp: _vm.hcpUp },
                                  { hcpDown: _vm.hcpDown }
                                ]
                              },
                              [_c("span", [_vm._v(_vm._s(_vm.handicap))])]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "selection-price float-right",
                          class: "pricetype-" + _vm.pricetype
                        },
                        [
                          !_vm.isClosed && !_vm.isSuspended
                            ? [
                                _vm.isOddsBoost
                                  ? _c("span", { staticClass: "arrow-blue" })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "price",
                                    class: [
                                      { priceUp: _vm.priceUp },
                                      { priceDown: _vm.priceDown }
                                    ]
                                  },
                                  [_vm._v(_vm._s(_vm.price))]
                                )
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isClosed || _vm.isSuspended
                            ? _c("span", { staticClass: "price" }, [
                                _vm.isClosed
                                  ? _c("span", { staticClass: "price_title" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("BetSlip.selection.isClosed")
                                        )
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.isSuspended
                                  ? _c("span", { staticClass: "price_title" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "BetSlip.selection.isSuspended"
                                          )
                                        )
                                      )
                                    ])
                                  : _vm._e()
                              ])
                            : _vm._e()
                        ],
                        2
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "market-name" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            (_vm.market && _vm.market.name) || _vm.marketName
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.showEventTsStart
                      ? _c(
                          "div",
                          { staticClass: "eventTsStart market-name" },
                          [
                            _vm.showEventTsStart
                              ? _c("ts-start", {
                                  attrs: {
                                    tsstart:
                                      _vm.market.tsstartWithOffset ||
                                      _vm.market.tsstart
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                ])
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.betslipLayout2
          ? _c(
              "div",
              {
                staticClass: "column column-right",
                on: {
                  click: function($event) {
                    return _vm.toggleOptedIn()
                  }
                }
              },
              [
                _c("label", { attrs: { for: _vm.id } }, [
                  _c("div", { staticClass: "selection-data" }, [
                    _c("div", { staticClass: "selection-name" }, [
                      _c("span", { staticClass: "name" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.selectionName) +
                            "\n                "
                        ),
                        _vm.selection &&
                        typeof _vm.selection.currenthandicap == "number"
                          ? _c(
                              "span",
                              {
                                staticClass: "currenthandicap",
                                class: [
                                  { hcpUp: _vm.hcpUp },
                                  { hcpDown: _vm.hcpDown }
                                ]
                              },
                              [_c("span", [_vm._v(_vm._s(_vm.handicap))])]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "selection-price float-right",
                          class: "pricetype-" + _vm.pricetype
                        },
                        [
                          !_vm.isClosed && !_vm.isSuspended
                            ? [
                                _vm.isOddsBoost
                                  ? _c("span", { staticClass: "arrow-blue" })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "price",
                                    class: [
                                      { priceUp: _vm.priceUp },
                                      { priceDown: _vm.priceDown }
                                    ]
                                  },
                                  [_vm._v(_vm._s(_vm.price))]
                                )
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isClosed || _vm.isSuspended
                            ? _c("span", { staticClass: "price" }, [
                                _vm.isClosed
                                  ? _c("span", { staticClass: "price_title" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("BetSlip.selection.isClosed")
                                        )
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.isSuspended
                                  ? _c("span", { staticClass: "price_title" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "BetSlip.selection.isSuspended"
                                          )
                                        )
                                      )
                                    ])
                                  : _vm._e()
                              ])
                            : _vm._e()
                        ],
                        2
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "event-name" }, [
                      _c("span", { staticClass: "eventname" }, [
                        _c("span", { staticClass: "name-lines" }, [
                          _c("span", { staticClass: "name-line" }, [
                            _vm._v(_vm._s(_vm.wbr(_vm.eventName, 0)))
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "name-line" }, [
                            _vm._v(_vm._s(_vm.wbr(_vm.eventName, 1)))
                          ])
                        ]),
                        _vm._v(" "),
                        _vm.isForBB
                          ? _c(
                              "span",
                              { staticClass: "isForBB" },
                              [
                                _c("icon", {
                                  attrs: { name: "icon-available-for-bb" }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isLive
                          ? _c("span", { staticClass: "isLive" }, [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("BetSlip.selection.isLive"))
                                )
                              ])
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "market-name" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            (_vm.market && _vm.market.name) || _vm.marketName
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.showEventTsStart
                      ? _c(
                          "div",
                          { staticClass: "eventTsStart market-name" },
                          [
                            _vm.showEventTsStart
                              ? _c("ts-start", {
                                  attrs: {
                                    tsstart:
                                      _vm.market.tsstartWithOffset ||
                                      _vm.market.tsstart
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                ])
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.selection &&
      _vm.selection.isPitcherSource &&
      _vm.currentBetSlipState <= 1
        ? _c("listed-pitchers", {
            attrs: {
              tab: _vm.tab,
              id: _vm.selection.idfoselection,
              marketName: _vm.marketName,
              currentBetSlipState: _vm.currentBetSlipState
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.selection &&
      _vm.selection.isBuyPointsSource &&
      _vm.currentBetSlipState <= 1
        ? _c("buy-points-option", {
            attrs: {
              tab: _vm.tab,
              id: _vm.selection.idfoselection,
              selection: _vm.selection,
              currentBetSlipState: _vm.currentBetSlipState
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a6168d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a6168d4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/betslipV2/selections/selectionRr.vue
// module id = null
// module chunks = 